import React, { useState } from "react";
import { NavLink } from "react-router-dom";
// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Pagination, Navigation } from "swiper";

export default function PopStores({ bgcolor, title, logo, image, data }) {
  return (
    <div className="popstores">
      <div className="popstore-main">
        {/* {data.length > 0 && (
        <div
          className="mt-4 d-flex align-items-center popstores"
          style={{ height: "180px", backgroundColor: bgcolor }}
        >
          <div className="d-flex popstore1">
            <div className="mx-2">
              <img src={logo} style={{ width: "200px", maxHeight: "140px" }} />
            </div>
            <div className="mt-0 pt-0 text-center ">
              <div
                className="d-flex justify-content-between mt-0 pt-0 sale"
                style={{ width: "200px" }}
              >
                <img
                  src={image}
                  style={{ transform: "scaleX(-1)", width: "60px" }}
                />
                <img src={image} style={{ width: "60px", top: "0" }} />
              </div>
              <h6
                className="mt-3 fw-bold popstore-title text-center"
                style={{ color: "#F0162E", width: "170px" }}
              >
                {title}
              </h6>
            </div> */}
        {/* </div> */}

        {/* <Swiper
        spaceBetween={30}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false
        }}
        modules={[Autoplay]}
        breakpoints={{
          1200: {
            slidesPerView: 6,
            spaceBetween: 20
          },
          1000: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          800: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          600: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          480: {
            slidesPerView: 2.5,
            spaceBetween: 20
          },
          400: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        }}
        className="mySwiper"
      > */}
        <Swiper
          dir="rtl"
          spaceBetween={40}
          breakpoints={{
            1200: {
              slidesPerView: 8
            },
            1000: {
              slidesPerView: 6
            },
            800: {
              slidesPerView: 5
            },
            600: {
              slidesPerView: 4
            },
            450: {
              slidesPerView: 3
            },
            300: {
              slidesPerView: 2
            }
          }}
          className="swiper py-4 px-2"
        >
          {data.map(value => {
            return (
              <SwiperSlide>
                <div
                  className=" rounded-circle align-items-center justify-content-center d-flex bg-white text-center px-3 mx-3 logo"
                  style={{
                    width: "120px",
                    height: "100px"
                  }}
                >
                  <NavLink
                    to={`/supplier/${value.suppliers__id}`}
                    target="blank"
                  >
                    <div className="my-auto text-center d-flex flex-column ">
                      <img
                        src={`http://sabadi.tatdemo.ir/${value.path}`}
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%"
                        }}
                      />
                    </div>
                  </NavLink>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {/* </div> */}
        {/* // )} */}
      </div>
    </div>
  );
}
